import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3539003d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "float-menu-content"
};
const _hoisted_2 = {
  class: "float-menu-item all",
  "data-icon": "all"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部", -1));
const _hoisted_4 = {
  class: "float-menu-item laoge",
  "data-icon": "laoge"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "老哥", -1));
const _hoisted_6 = {
  class: "float-menu-item laojie",
  "data-icon": "laojie"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "老姐", -1));
const _hoisted_8 = {
  class: "float-menu-item official",
  "data-icon": "official"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "官方", -1));
const _hoisted_10 = {
  class: "float-menu-item baojian",
  "data-icon": "baojian"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "爆奖", -1));
import { inject, ref } from "vue";
import { useRouter } from 'vue-router';
import { homeCategoryTable, forumCategoryTable } from "@/composable/commonFunction/categoryTable";
export default {
  __name: 'duFloatMenu',
  setup(__props, {
    expose
  }) {
    const router = useRouter();
    const {
      switchHeaderTab
    } = inject('activeHeaderTab');
    const {
      switchCategory
    } = inject('categoryTab');
    const duFloatMenuTimeoutId = ref();
    // 強制關閉選單
    const forceHiddenDuFloatMenu = () => {
      removeDufloatMenuActiveStyle();
      clearTimeout(duFloatMenuTimeoutId.value);
      document.querySelector('.du-float-menu').classList.add('hidden');
    };
    // 滑鼠移過事件
    const duFloatMenuMouseOver = event => {
      clearTimeout(duFloatMenuTimeoutId.value);
      if (!event.target.classList.contains('float-menu-item') || !event.target.closest('div.float-menu-item')) {
        return;
      }
      removeDufloatMenuActiveStyle();
      const divElement = event.target.closest('div.float-menu-item');
      divElement.querySelector('span').classList.add('active');
      divElement.querySelector('img').src = divElement.querySelector('img').dataset.hover;
    };
    // 移除hover效果
    const removeDufloatMenuActiveStyle = () => {
      document.querySelectorAll('.float-menu-item span').forEach(item => {
        item.classList.remove('active');
      });
      document.querySelectorAll('.float-menu-item img').forEach(item => {
        item.src = item.dataset.src;
      });
    };
    // 滑鼠移出事件
    const duFloatMenuMouseOut = event => {
      removeDufloatMenuActiveStyle();
      duFloatMenuTimeoutId.value = setTimeout(() => {
        document.querySelector('.du-float-menu').classList.add('hidden');
      }, 1000);
    };
    // 點擊和路由跳轉
    const duFloatMenuClick = event => {
      if (!event.target.classList.contains('float-menu-item') || !event.target.closest('div.float-menu-item')) {
        return;
      }
      document.querySelector('.du-float-menu').classList.add('hidden');
      const divElement = event.target.closest('div.float-menu-item');
      const val = divElement.dataset.icon;
      switchHeaderTab('recommend');
      switchCategory({
        key: val
      });
      if (val === 'all') {
        //推薦—全部才走這個路由
        const forum = homeCategoryTable.filter(item => item.key === 'all')[0];
        router.push({
          name: 'home',
          query: {
            forum: forum.val
          }
        });
        return;
      } else {
        const forum = forumCategoryTable.filter(item => item.key.split('-')[0] === val && item.top)[0];
        router.push({
          name: 'forum',
          params: {
            fid: forum.fid,
            type: forum.type
          },
          query: {
            order: forum.order ? 'dateline' : undefined
          }
        });
        return;
      }
    };
    expose({
      forceHiddenDuFloatMenu,
      duFloatMenuMouseOut,
      duFloatMenuTimeoutId
    });
    return (_ctx, _cache) => {
      const _component_image_cdn = _resolveComponent("image-cdn");
      return _openBlock(), _createElementBlock("div", {
        class: "du-float-menu hidden",
        onMouseover: duFloatMenuMouseOver,
        onMouseout: duFloatMenuMouseOut,
        onClick: duFloatMenuClick
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_image_cdn, {
        src: require(`@/assets/images/pc/icons/menu-all-normal@2x.png`),
        "data-src": require(`@/assets/images/pc/icons/menu-all-normal@2x.png`),
        "data-hover": require(`@/assets/images/pc/icons/menu-all-hover@2x.png`)
      }, null, 8, ["src", "data-src", "data-hover"]), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_image_cdn, {
        src: require(`@/assets/images/pc/icons/menu-laoge-normal@2x.png`),
        "data-src": require(`@/assets/images/pc/icons/menu-laoge-normal@2x.png`),
        "data-hover": require(`@/assets/images/pc/icons/menu-laoge-hover@2x.png`)
      }, null, 8, ["src", "data-src", "data-hover"]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_image_cdn, {
        src: require(`@/assets/images/pc/icons/menu-laojie-normal@2x.png`),
        "data-src": require(`@/assets/images/pc/icons/menu-laojie-normal@2x.png`),
        "data-hover": require(`@/assets/images/pc/icons/menu-laojie-hover@2x.png`)
      }, null, 8, ["src", "data-src", "data-hover"]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_image_cdn, {
        src: require(`@/assets/images/pc/icons/menu-official-normal@2x.png`),
        "data-src": require(`@/assets/images/pc/icons/menu-official-normal@2x.png`),
        "data-hover": require(`@/assets/images/pc/icons/menu-official-hover@2x.png`)
      }, null, 8, ["src", "data-src", "data-hover"]), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_image_cdn, {
        src: require(`@/assets/images/pc/icons/menu-baojian-normal@2x.png`),
        "data-src": require(`@/assets/images/pc/icons/menu-baojian-normal@2x.png`),
        "data-hover": require(`@/assets/images/pc/icons/menu-baojian-hover@2x.png`)
      }, null, 8, ["src", "data-src", "data-hover"]), _hoisted_11])])], 32);
    };
  }
};